import { render, staticRenderFns } from "./EllipsisText.vue?vue&type=template&id=24d6889e&scoped=true"
import script from "./EllipsisText.vue?vue&type=script&lang=ts"
export * from "./EllipsisText.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./EllipsisText.vue?vue&type=style&index=0&id=24d6889e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "24d6889e",
  "640f7c9d"
  
)

export default component.exports